var indexOf = [].indexOf

$.fn.hideDependencies = function(dependencies, opts) {
  let container = this
  if (opts == null) {
    opts = {}
  }
  let inputHash = {}
  let incomingDependencies = {}
  let outgoingDependencies = {}
  let initialize_element_attributes = function() {
    return $(container).data("has_dependencies", true)
  }

  let clean_up_name = function(dirty_name) {
    dirty_name = dirty_name.replace(/_ids$/, "s")
    dirty_name = dirty_name.replace(/_id$/, "")
    return dirty_name
  }

  let get_field_from_div = function(inputdiv) {
    var input, name, part, parts
    name = null
    input = inputdiv.find(":input[name]").first()
    if (input.length) {
      if (input.attr("name") !== void 0) {
        name = input.attr("name")
        name = clean_up_name(name)
        name = name.replace(/\]/g, "")
        parts = name.split("[")
        parts = (function() {
          var j, len, results
          results = []
          for (j = 0, len = parts.length; j < len; j++) {
            part = parts[j]
            part = part.replace(/_attributes$/, "")
            part = part.replace(/\([0-9]i\)$/, "")
            results.push(part)
          }
          return results
        })()

        parts = (function() {
          var j, len, results
          results = []
          for (j = 0, len = parts.length; j < len; j++) {
            part = parts[j]
            if (part !== "" && !part.match(/^[0-9]+$/)) {
              results.push(part)
            }
          }
          return results
        })()

        name = parts.join(".")
      }
    }
    return name
  }

  let build_input_hash = function () {
    return container.find("div.input").each(function(i, inputdiv) {
      inputdiv = $(inputdiv)
      var id = get_field_from_div(inputdiv)

      if (id !== null) {
        id = clean_up_name(id)
        return inputHash[id] = inputdiv
      }
    })
  }

  let get_input = function(field) {
    field = clean_up_name(field)
    return inputHash[field]
  }

  let prune_invalid_fields = function(fields) {
    var field, j, len, results
    results = []
    for (j = 0, len = fields.length; j < len; j++) {
      field = fields[j]
      if (get_input(field) != null) {
        results.push(field)
      }
    }
    return results
  }

  let prune_invalid_conditions = function(conditions) {
    var name, newConditions, subcondition, value
    newConditions = {}
    for (name in conditions) {
      value = conditions[name]
      if (name === "or") {
        newConditions[name] = (function() {
          var j, len, ref, results
          ref = conditions["or"]
          results = []
          for (j = 0, len = ref.length; j < len; j++) {
            subcondition = ref[j]
            results.push(prune_invalid_conditions(subcondition))
          }
          return results
        })()
      } else {
        name = clean_up_name(name)
        if (!(get_input(name) != null)) {
          continue
        }
        newConditions[name] = value
      }
    }
    return newConditions
  }

  let assign_outgoing_dependencies = function(conditions, newDependency) {
    var name, results, subconditions, value
    results = []
    for (name in conditions) {
      value = conditions[name]
      if (name === "or") {
        results.push((function() {
          var j, len, results1
          results1 = []
          for (j = 0, len = value.length; j < len; j++) {
            subconditions = value[j]
            results1.push(assign_outgoing_dependencies(subconditions, newDependency))
          }
          return results1
        })())
      } else {
        if (outgoingDependencies[name] == null) {
          outgoingDependencies[name] = []
        }
        results.push(outgoingDependencies[name].push(newDependency))
      }
    }
    return results
  }

  let assign_incoming_dependencies = function(fields, newDependency) {
    var field, j, len, results
    results = []
    for (j = 0, len = fields.length; j < len; j++) {
      field = fields[j]
      if (incomingDependencies[field] == null) {
        incomingDependencies[field] = []
      }
      results.push(incomingDependencies[field].push(newDependency))
    }
    return results
  }

  let prepare_dependency_lookups = function () {
    return dependencies = dependencies.map(function (dependency) {
      let conditions = dependency[1]
      let fields = dependency[0]

      let newDependency = {}

      let cleanFields = prune_invalid_fields(fields)
      let cleanConditions = prune_invalid_conditions(conditions)

      newDependency.fields = cleanFields
      newDependency.conditions = cleanConditions
      newDependency.met = null

      assign_incoming_dependencies(cleanFields, newDependency)
      assign_outgoing_dependencies(cleanConditions, newDependency)

      return newDependency
    })
  }


  let string_to_value = function(string) {
    if (string === "on" || string === "") {
      return null
    } else if (string === "t" || string === "true") {
      return true
    } else if (string === "f" || string === "false") {
      return false
    } else if (!isNaN(parseFloat(string))) {
      return parseFloat(string)
    } else {
      return string
    }
  }

  let get_value = function(field) {
    var fragment, j, len, ref, value
    field = clean_up_name(field)
    var input = get_input(field)
    var result = null

    if ((input != null) && (input.css("display") !== "none" || indexOf.call(input.attr("class").split(" "), "hidden") >= 0)) {
      ref = input.find(":input").serializeAll()
      // Note that this relies on the serializeAll plugin from stack overflow
      for (j = 0, len = ref.length; j < len; j++) {
        fragment = ref[j]
        value = string_to_value(fragment.value)
        if (fragment.name.match(/_ids\]\[\]$/)) {
          if (result == null) {
            result = []
          }
          if (value != null) {
            result = result.concat(value)
          }
        } else {
          result = value
        }
      }
    }
    return result
  }

  let matches = function(given, required) {
    var e, intersection, inverse, result
    if (given === void 0) {
      return false
    }
    if (!$.isArray(given)) {
      given = [given]
    }
    inverse = false
    if (!$.isArray(required) && typeof required === "object") {
      if (typeof required.not !== "undefined") {
        inverse = true
        required = required.not
      } else {
        console.log("bad condition!")
        console.log(required)
      }
    }
    if (!$.isArray(required)) {
      required = [required]
    }
    intersection = (function() {
      var j, len, results
      results = []
      for (j = 0, len = required.length; j < len; j++) {
        e = required[j]
        if (indexOf.call(given, e) >= 0) {
          results.push(e)
        }
      }
      return results
    })()
    result = intersection.length > 0
    if (inverse) {
      return !result
    } else {
      return result
    }
  }

  let conditions_fulfilled = function(conditions) {
    var field, required, result
    for (field in conditions) {
      required = conditions[field]
      if (field === "or") {
        result = required.reduce(function(memo, subconditions) {
          return memo || conditions_fulfilled(subconditions)
        }, false)
        if (!result) {
          return false
        }
      } else {
        if (!matches(get_value(field), required)) {
          return false
        }
      }
    }
    return true
  }

  let check_dependency = function(dependency, forcecheck = false) {
    var conditions, f, j, len, old_dependency_result, ref
    old_dependency_result = dependency.met
    if ((old_dependency_result === null) || forcecheck) {
      conditions = dependency.conditions
      dependency.met = conditions_fulfilled(conditions)
      if (old_dependency_result !== dependency.met) {
        ref = dependency.fields
        for (j = 0, len = ref.length; j < len; j++) {
          f = ref[j]
          update_field(f)
        }
      }
    }
    return dependency.met
  }

  let update_field = function(field) {
    var input = get_input(field)

    let should_be_visible = !function () {
      var ref = incomingDependencies[field]
      var results = []

      // if (field == "missing_info_system_basics.nameplate_capacity") { debugger }
      ref.forEach(function (d) {
        if (!check_dependency(d)) {
          results.push(d)
        }
      })
      return results
    }().length

    var visible = input.css("display") !== "none"
    if (should_be_visible) {
      input.find(":input").removeAttr("disabled")
      input.show()
    } else {
      input.hide()
      input.find(":input").attr("disabled", true)
    }
    if (should_be_visible !== visible) {
      return field_changed(field)
    }
  }

  let field_changed = function(field) {
    var d, j, len, outgoing, results
    field = clean_up_name(field)
    outgoing = outgoingDependencies[field]
    if (outgoing != null) {
      results = []
      for (j = 0, len = outgoing.length; j < len; j++) {
        d = outgoing[j]
        results.push(check_dependency(d, true))
      }
      return results
    }
  }

  let hide_empty_sections = function() {
    return container.find("fieldset section").each(function(i, x) {
      var visibleChildren
      visibleChildren = $(x).find("div.input").filter(function() {
        return $(this).css("display") !== "none"
      })
      if (visibleChildren.size() > 0) {
        return $(x).show()
      } else {
        return $(x).hide()
      }
    })
  }

  var initialize_dependencies = function () {
    build_input_hash()
    prepare_dependency_lookups()

    dependencies.forEach(function (dependency) { check_dependency(dependency) } )
    hide_empty_sections()

    var results = []
    for (const field in outgoingDependencies) {
      results.push(get_input(field).find(":input").change(function () {
        var theField = get_field_from_div($(this).closest("div.input"))
        field_changed(theField)
        return hide_empty_sections()
      }))
    }
    return results
  }

  // Get everything started
  initialize_dependencies()
  initialize_element_attributes()
  return true
}
